import { ElementRef, Directive, NgModule } from '@angular/core';
import 'jquery-nice-select';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgNiceSelectDirective {
    /**
     * @param {?} el
     */
    constructor(el) {
        this.el = el;
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        $(this.el.nativeElement).niceSelect();
        this.attachAngularChange();
        this.attachObserver();
    }
    /**
     * @return {?}
     */
    attachAngularChange() {
        $(this.el.nativeElement).one('change', () => {
            /** @type {?} */
            const customEvent = document.createEvent('Event');
            customEvent.initEvent('change', true, true);
            this.el.nativeElement.dispatchEvent(customEvent);
            this.attachAngularChange();
        });
    }
    /**
     * @return {?}
     */
    attachObserver() {
        this.observer = new MutationObserver(mutations => {
            mutations.forEach(() => this.onChanges());
        });
        this.observer.observe(this.el.nativeElement, {
            attributes: true,
            childList: true,
            characterData: true
        });
    }
    /**
     * @return {?}
     */
    detachObserver() {
        this.observer.disconnect();
    }
    /**
     * @return {?}
     */
    onChanges() {
        this.detachObserver();
        $(this.el.nativeElement).niceSelect('update');
        this.attachObserver();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.detachObserver();
        $(this.el.nativeElement).niceSelect('destroy');
    }
}
NgNiceSelectDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nice-select]',
            },] }
];
/** @nocollapse */
NgNiceSelectDirective.ctorParameters = () => [
    { type: ElementRef }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NiceSelectModule {
}
NiceSelectModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NgNiceSelectDirective],
                imports: [],
                exports: [NgNiceSelectDirective]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NiceSelectModule, NgNiceSelectDirective as ɵa };

//# sourceMappingURL=ng-nice-select.js.map